import React, { FC } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import ListItem from '@mui/material/ListItem';

import { ITeamDTO } from 'src/api/dtos';
import { Tooltip } from 'src/shared/components';

interface Props {
  team: ITeamDTO;
  checked: boolean;
  onSelect: (team: ITeamDTO) => void;
}

export const MultiTeamOption: FC<Props> = ({ team, checked, onSelect }) => {
  return (
    <ListItem key={team.id} sx={{ p: 0, m: 0 }}>
      <Tooltip title={team.description} placement="left" showIcon={false}>
        <FormControlLabel
          onClick={(event) => {
            onSelect(team);
            event.stopPropagation();
            event.preventDefault();
          }}
          control={<Checkbox size="small" checked={checked} />}
          label={team.description}
          sx={{
            width: '100%',
            flex: 1,
            margin: 0,
            padding: '0 7px',
            '.MuiFormControlLabel-label': {
              fontSize: '0.875rem',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            },
          }}
        />
      </Tooltip>
    </ListItem>
  );
};
